import { render, staticRenderFns } from "./ManageUrbanismRegulationZonesModal.vue?vue&type=template&id=1fbf0413&"
import script from "./ManageUrbanismRegulationZonesModal.vue?vue&type=script&lang=js&"
export * from "./ManageUrbanismRegulationZonesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports